import React, { Component } from "react";
import Doctor from "../Assets/doctor-picture.png"; // Replace with your lab-related image
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import "../Styles/Hero.css";
import PlayStoreIcon from "../Assets/playstore.png"; // Play Store circular image
import AppStoreIcon from "../Assets/appstore.png"; // App Store circular image

class Hero extends Component {
  constructor(props) {
    super(props);
    this.state = { goUp: false };
  }

  scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  handleScroll = () => {
    this.setState({ goUp: window.scrollY > 600 });
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  render() {
    return (
      <div className="section-container">
        <div className="hero-section">
          <div className="text-section">
            <p className="text-headline">🔬 Health at Your Fingertips</p>
            <h2 className="text-title">
              Book Lab Tests and Order Medicines Instantly
            </h2>

            {/* 📲 Download Heading */}
            <h3 className="download-heading"> Download Our App</h3>

            {/* App Download Buttons */}
            <div className="app-download-buttons">
              <a
                href="https://play.google.com/store/apps/details?id=com.aidnix&hl=en-US"
                target="_blank"
                rel="noopener noreferrer"
                className="store-button"
              >
                <img className="store-icon" src={PlayStoreIcon} alt="Google Play" />
                <span>Google Play</span>
              </a>

              <a
                href="https://apps.apple.com/app/6509232716"
                target="_blank"
                rel="noopener noreferrer"
                className="store-button"
              >
                <img className="store-icon" src={AppStoreIcon} alt="App Store" />
                <span>App Store</span>
              </a>
            </div>

            <div className="text-stats">
              <div className="text-stats-container">
                <p>5k+</p>
                <p>Lab Tests Completed</p>
              </div>

              <div className="text-stats-container">
                <p>100+</p>
                <p>Certified Laboratories</p>
              </div>

              <div className="text-stats-container">
                <p>5k+</p>
                <p>Medicines Delivered</p>
              </div>
            </div>
          </div>

          <div className="hero-image-section">
            <img className="hero-image1" src={Doctor} alt="Lab" />
          </div>
        </div>

        <div
          onClick={this.scrollToTop}
          className={`scroll-up ${this.state.goUp ? "show-scroll" : ""}`}
        >
          <FontAwesomeIcon icon={faAngleUp} />
        </div>
      </div>
    );
  }
}

export default Hero;